import InputSliderBlock, {
  InputSliderBlockValue,
} from 'components/Shared/SearchFilter/InputSliderBlock';
import { srpFilterInitialValues } from 'redux-implementations/srpFilters';

export default function MileageInput({
  onChange,
}: {
  onChange: (val: InputSliderBlockValue) => void;
}): JSX.Element {
  return (
    <InputSliderBlock
      onChange={onChange}
      minAllowed={0}
      maxAllowed={srpFilterInitialValues.Mileage.max}
      initialMin={0}
      initialMax={300000}
      minPlaceholder={'0'}
      maxPlaceholder={'300,000+'}
      pushable={0}
      step={1000}
      hasThousandSeparator={true}
      disableMinChange
      getMinSuffix={(): string => 'mi.'}
      getMaxSuffix={({ numericValue }): string | undefined =>
        numericValue && numericValue >= srpFilterInitialValues.Mileage.max ? '+ mi.' : ' mi.'
      }
    />
  );
}
